import { JsonObject } from 'json2typescript';
import { PortfolioanalysisSumaryInterface } from '../interfaces/portfolioanalysis-sumary.interface';

@JsonObject('Portfolioanalysis')
export class Portfolioanalysis implements PortfolioanalysisSumaryInterface {
  Alias?: string;
  Code?: string;
  Contributions?: number;
  Currency?: string;
  EndDate?: string;
  Id?: string;
  InitialDate?: string;
  IsGrouped?: boolean;
  LiabilitiesValuation?: number;
  Name?: string;
  PerformanceBeetweenDates?: number;
  PerformanceData?: PerformanceData[];
  PerformanceIndexes?: PerformanceIndexes;
  ProfitLossData?: ProfitLossData[];
  PortfolioCode?: string;
  PortfolioType?: string;
  ShowProfitLossInClientPortal?: boolean;
  SameCode?: any;
  TotalEndDate?: string;
  TotalInitialDate?: string;
  TotalProfitLossBeetweenDates?: number;
  UnrealizedGains?: number;
  UnrealizedGainsPercent?: number;
  ValuationEndDate?: number;
  ValuationInitialDate?: number;
  Withdrawals?: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('PerformanceIndexes')
export class PerformanceIndexes {
  BenchmarksIndex?: any[];
  PortfolioIndex?: PortfolioIndex;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('PortfolioIndex')
export class PortfolioIndex {
  Dates?: string[];
  PortfolioPerformances?: number[];
  PortfolioValuations?: number[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('PerformanceData')
export class PerformanceData {
  Code?: string;
  Id?: string;
  Name?: string;
  Performance1M?: number;
  Performance1W?: number;
  Performance1Y?: number;
  Performance3M?: number;
  Performance3Y?: number;
  Performance5Y?: number;
  PerformanceDateToDate?: number;
  PerformanceStartDate?: number;
  PerformanceYTD?: number;
  Type?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('ProfitLossData')
export class ProfitLossData {
  Code?: string;
  Id?: string;
  Name?: string;
  ProfitLossLastWeek?: number;
  ProfitLoss1M?: number;
  ProfitLossYTD?: number;
  ProfitLoss1Y?: number;
  ProfitLossDateToDate?: number;
  ProfitLossStartDate?: number;
  Type?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
